import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from "./Footer";
import Header from "./Header";
import 'flatpickr/dist/flatpickr.min.css';
import BookingConfirmationImg from './assets/img/BookingConfirmationImg.png';


const BookingConfirmation = () => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(true); // Default to open
    const location = useLocation();
        const bookingData = location.state?.bookingData ||location.state?.fallbackBookingData;
        console.log("Booking Data:", bookingData);
      const directions = bookingData.FlightInfo?.Directions || [];
    const isRoundTrip = bookingData.SearchInfo?.journeyType === "2";
    const departureSegments = directions[0]?.[0]?.Segments || [];
      console.log("Is Round Trip:", isRoundTrip);
      const returnSegments = isRoundTrip ? directions[1]?.[0]?.Segments || [] : [];
      const segments = isRoundTrip ? [...departureSegments, ...returnSegments] : departureSegments;
    // console.log("Directions:", directions);
    // console.log("Departure:", directions[0]);
    // console.log("Return:", directions[1]);
    
       
        if (!bookingData) {
            return <p>Loading booking details...</p>;
        }
    

    return (
        <>
            <Header></Header>
            <div className="mainContent">
                <div className="confirmedConWrap">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-sm-6">
                                <div className="imgWrap">
                                    <img src={BookingConfirmationImg} className="img-fluid" alt="" />
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="icoWrap">
                                    <div className="innerWrap">
                                        <svg width="42" height="32" viewBox="0 0 42 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.5315 31.3354C15.1811 31.3343 14.8347 31.2611 14.5137 31.1204C14.1928 30.9797 13.9042 30.7745 13.6659 30.5176L1.24594 17.3054C0.781661 16.8106 0.53295 16.1517 0.554517 15.4735C0.576084 14.7954 0.866162 14.1535 1.36094 13.6893C1.85571 13.225 2.51466 12.9763 3.19281 12.9979C3.87096 13.0194 4.51277 13.3095 4.97705 13.8043L15.5059 25.0232L36.9982 1.51205C37.2163 1.24045 37.4876 1.01631 37.7955 0.853389C38.1034 0.69047 38.4413 0.592212 38.7886 0.564652C39.1358 0.537092 39.485 0.580812 39.8147 0.693125C40.1445 0.805438 40.4478 0.983974 40.706 1.21777C40.9642 1.45156 41.1719 1.73567 41.3163 2.05266C41.4607 2.36964 41.5388 2.71281 41.5458 3.06107C41.5528 3.40933 41.4885 3.75535 41.3568 4.07786C41.2252 4.40036 41.029 4.69256 40.7804 4.93649L17.4226 30.4921C17.1866 30.7536 16.899 30.9636 16.578 31.1087C16.2569 31.2538 15.9093 31.331 15.557 31.3354H15.5315Z" fill="black" />
                                        </svg>
                                    </div>
                                </div>
                                <div className="topDataWrap">
                                    <h2>Congratulation!</h2>
                                    <p>You have Booked your flight succesfully.</p>
                                    <p>Your ticket will be sent to your email shortly.</p>
                                    <p><strong>Booking UniqueTransID:</strong> {bookingData.BookingTransactionRef || bookingData.bookingRef}</p>
                                    <p><strong>Booking Status:</strong> {bookingData.BookingStatus}</p>
                                    {/* <p><strong>Booking Transaction Ref:</strong> {bookingData.BookingTransactionRef}</p> */}
                                    <p>Thank you for choosing <strong>Travasco</strong> – we look forward to your journey with us!</p>
                                </div>
                                {/* <div className="btmDataWrap">
                                    <h4>Confirmation Details have been sent to</h4>
                                    <ul>
                                        <li>
                                            <p>SMS: <span>{bookingData?.TicketInfoes[0]?.PassengerInfo?.ContactInfo?.PhoneCountryCode}  {bookingData?.TicketInfoes[0]?.PassengerInfo?.ContactInfo?.Phone}</span></p>
                                        </li>
                                        <li>
                                            <p>Email ID: <span>{bookingData?.TicketInfoes[0]?.PassengerInfo?.ContactInfo?.Email}</span></p>
                                        </li>
                                    </ul>
                                 <div className="codResendWrap">
                                        <button className="btn">Resend</button>
                                        <p>00:00</p>
                                    </div> 
                                    
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer></Footer>
        </>
    );
}
export default BookingConfirmation;